import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'dayjs/locale/zh-cn';
import 'element-plus/dist/index.css'
import 'font-awesome/css/font-awesome.min.css'
import '@/styles/index.scss' // global css

import ElIcons from './components/ElIcons'
import ElButtons from './components/ElButtons'
import BtnGroup from '@/components/BtnGroup'
import HeadImg from "@/components/HeadImg";
import PageDesc from "@/components/pageDesc"


global.HOST = '/oapi'

const app = createApp(App)


app.directive('high-light', {
  beforeMount: function (el, binding) {
    let value = binding.value;
    let changeValue = value.value;
    let array = changeValue.split('');
    let allStr = '';
    for(let i=0;i<array.length;i++) {
      let str = array[i] + array[i+1] + array[i+2] + array[i+3] + array[i+4];
      if(str == '充值备注：' || str == '预约备注：' || str == '回访备注：') {
        allStr += "<font style='font-weight: bold'>" + str + "</font>";
        i += 4;
      }else{
        allStr += array[i];
      }
    }
    el.innerHTML = allStr;
  },
  updated: function (el, binding) {
    let value = binding.value;
    let changeValue = value.value;
    let array = changeValue.split('');
    let allStr = '';
    for(let i=0;i<array.length;i++) {
      let str = array[i] + array[i+1] + array[i+2] + array[i+3] + array[i+4];
      if(str == '充值备注：' || str == '预约备注：' || str == '回访备注：') {
        allStr += "<font style='font-weight: bold'>" + str + "</font>";
        i += 4;
      }else{
        allStr += array[i];
      }
    }
    el.innerHTML = allStr;
  }
})


app.component('ElIcons', ElIcons)
app.component('ElButtons', ElButtons)
app.component('BtnGroup', BtnGroup)
app.component('HeadImg', HeadImg)
app.component('PageDesc', PageDesc)
app.use(ElementPlus, { size: 'default', zIndex: 3000, locale: zhCn })
app.use(store).use(router).mount('#app')
